import { VStack, Avatar, Text, Flex, Spinner, Button } from '@chakra-ui/react'
import { ParentSearchResult } from './type'

interface ParentSearchResultsProps {
    parents: ParentSearchResult[]
    loading: boolean
    onSelectParent?: (parent: ParentSearchResult) => void
}

export default function ParentSearchResults({
    parents,
    loading,
    onSelectParent
}: ParentSearchResultsProps) {
    if (loading) {
        return (
            <Flex justify="center" align="center" py={4}>
                <Spinner size="lg" />
            </Flex>
        )
    }

    if (parents.length === 0) {
        return (
            <Text textAlign="center" color="gray.500" py={4}>
                No result...
            </Text>
        )
    }

    return (
        <VStack spacing={4} align="stretch" minW={['80vw', '400px', '600px']}>
            {parents.map((parent) => (
                <Flex
                    key={parent._id}
                    align={['', 'center']}
                    p={4}
                    borderWidth={1}
                    borderRadius="md"
                    gap={4}
                    direction={['column', 'row']}
                    cursor={onSelectParent ? 'pointer' : 'default'}
                    _hover={{
                        bg: 'gray.50',
                        transform: 'scale(1.01)'
                    }}
                    boxShadow={'sm'}
                >
                    <Avatar
                        src={parent.picture}
                        name={`${parent.firstName} ${parent.lastName}`}
                        mr={4}
                    />
                    <VStack align="start" spacing={1} flex={1}>
                        <Text fontWeight="bold">
                            {parent.firstName} {parent.lastName}
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                            <strong>Branch:</strong> {parent?.branch?.name}
                        </Text>
                    </VStack>

                    <Button variant={'outline'} onClick={() => onSelectParent?.(parent)}>
                        Add Co-parent
                    </Button>
                </Flex>
            ))}
        </VStack>
    )
}
